import { useModalStore } from '@/shared/lib';
import { NUMERIC_CONFIG } from '@/shared/config';
import { useTranslation } from 'react-i18next';
import {
  ResultModal,
  WithdrawConfirmationModalContainer,
  WithdrawSbpModal,
  type WithdrawSbpModalState,
} from '@/features/withdraw-sbp';
// import { WithdrawHistoryModal } from '@/shared/components';
// import type { OperationHistoryParams } from '@/shared/types';
import { getCalculatedCommission } from '@/entities/operation';

export function useWithdrawSbpModals() {
  const { showDialogComponent, closeDialog, getState, cleanup, getAllState } =
    useModalStore();
  const { t } = useTranslation();

  const onCloseDialog = () => {
    closeDialog();
    cleanup();
  };

  const closeConfirmation = {
    title: t('withdrawMethods.crypto.exitConfirmTitle'),
    description: t('withdrawMethods.crypto.exitConfirmDescription'),
    confirmText: t('withdrawMethods.crypto.exitConfirmButton'),
    showCancelButton: false,
  };

  function getStoreData() {
    const storeData = getAllState<WithdrawSbpModalState>();

    const commissionData = getCalculatedCommission({
      amount: +storeData?.totalAmount || 0,
      assetCode: storeData?.withdrawSbpFormData?.currencyCode || '',
      includeFee: !!storeData?.withdrawSbpFormData?.includeFee,
      fee: storeData?.fee || 0,
      precision: NUMERIC_CONFIG.precision.default,
    });

    return {
      commissionData,
      storeData,
    };
  }

  const openResultModal = ({ success }: { success: boolean }) => {
    const { commissionData, storeData } = getStoreData();

    showDialogComponent({
      component: (
        <ResultModal
          success={success}
          data={{
            commissionData,
            phoneNumber: storeData.withdrawSbpFormData.phoneNumber,
            bankName: storeData.selectedBank.name,
          }}
          onClose={() => {
            if (success) {
              onCloseDialog();
              return;
            }

            openWithdrawSbpModal();
          }}
        />
      ),
      onClose: onCloseDialog,
    });
  };

  // const openWithdrawHistory = (historyParams?: OperationHistoryParams) => {
  //   showDialogComponent({
  //     component: (
  //       <WithdrawHistoryModal
  //         onBack={openWithdrawSbpModal}
  //         title={t('withdrawMethods.crypto.history.dialogTitle')}
  //         historyParams={historyParams}
  //       />
  //     ),
  //     onClose: onCloseDialog,
  //     closeConfirmation,
  //     skipBackButtonConfirmation: true,
  //     closeConfirmationRequired: true,
  //   });
  // };

  const openWithdrawSbpModal = () => {
    const openOperationMethodsModal = getState(
      'onWithdrawFormBack'
    ) as () => void;

    showDialogComponent({
      component: (
        <WithdrawSbpModal
          // Withdraw history is temporarily disabled
          // onHistoryClick={openWithdrawHistory}
          title={t('withdrawMethods.sbp.title')}
          onBack={() => {
            cleanup();
            openOperationMethodsModal();
          }}
        />
      ),
      onClose: onCloseDialog,
      preventOverlayClose: true,
      closeConfirmation,
      skipBackButtonConfirmation: false,
    });
  };

  const openConfirmationModal = (params?: { continueMFA?: boolean }) => {
    const { commissionData, storeData } = getStoreData();

    showDialogComponent({
      component: (
        <WithdrawConfirmationModalContainer
          onBack={openWithdrawSbpModal}
          storeData={storeData}
          commissionData={commissionData}
          continueMFA={params?.continueMFA}
        />
      ),
      onClose: onCloseDialog,
      preventOverlayClose: true,
    });
  };

  return {
    openWithdrawSbpModal,
    openConfirmationModal,
    openResultModal,
  };
}
